module.exports = __webpack_public_path__ + "static/img/tk.a19184cd.svg";